import React from "react";
import Chart from "react-apexcharts";
import Mstatus from "../../DashboardFiles/Dashboard/Mstatus";

// Financial Reports Chart
const FinancialReportsChart = () => {
  const options = {
    chart: { id: "financial-reports" },
    xaxis: {
      categories: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
    },
    title: { text: "Financial Reports", align: "left" },
    colors: ["#008FFB"],
    stroke: { curve: "smooth" },
  };

  const series = [
    {
      name: "Revenue",
      data: [30, 40, 35, 50, 49, 60, 70, 91, 125, 90, 100, 115],
    },
  ];

  return <Chart options={options} series={series} type="line" height={350} />;
};

// Distributor Performance Chart
const DistributorPerformanceChart = () => {
  const options = {
    chart: { id: "distributor-performance" },
    xaxis: {
      categories: [
        "John_doe",
        "jane_smith",
        "alice_johnson",
        "bob_martin",
      ],
    },
    title: { text: "Distributor Performance", align: "left" },
    colors: ["#FF4560", "#00E396", "#008FFB", "#775DD0"],
  };

  const series = [
    { name: "Share", data: [400, 430, 448, 470] },
    { name: "Targets", data: [450, 470, 430, 480] },
  ];

  return <Chart options={options} series={series} type="bar" height={350} />;
};

// Magazine Distribution Report Chart
const MagazineDistributionReportChart = () => {
  const options = {
    chart: { id: "magazine-distribution-report" },
    labels: ["Region A", "Region B", "Region C", "Region D"],
    title: { text: "Magazine Distribution Report", align: "left" },
    colors: ["#FF9800", "#E91E63", "#9C27B0", "#3F51B5"],
  };

  const series = [44, 55, 41, 17];

  return <Chart options={options} series={series} type="pie" height={350} />;
};

// Distribution Network Report Chart
const DistributionNetworkReportChart = () => {
  const options = {
    chart: { id: "distribution-network-report" },
    xaxis: { categories: ["North", "South", "East", "West"] },
    title: { text: "Distribution Network Report", align: "left" },
    colors: ["#00BFFF"],
    stroke: { curve: "smooth" },
  };

  const series = [{ name: "Units Distributed", data: [200, 300, 250, 400] }];

  return <Chart options={options} series={series} type="line" height={350} />;
};

// Admin Reports Component
const AdminReports = () => {
  return (
    <>
      <div className="mb-2 row">
       <Mstatus/>
      </div>

      <div className="admin-reports row">
        <div className="col-md-12 col-lg-6 mb-2" style={{ padding: "6px" }}>
          <div className="report-section bg-white p-3">
            <h4>Financial Reports</h4>
            <FinancialReportsChart />
          </div>
        </div>
        <div className="col-md-12 col-lg-6 mb-2" style={{ padding: "6px" }}>
          <div className="report-section bg-white p-3">
            <h4>Distributor Performance</h4>
            <DistributorPerformanceChart />
          </div>
        </div>
        <div className="col-md-12 col-lg-6 mb-2" style={{ padding: "6px" }}>
          <div className="report-section bg-white p-3 py-4">
            <h4>Magazine Distribution Report</h4>
            <MagazineDistributionReportChart />
          </div>
        </div>
        <div className="col-md-12 col-lg-6 mb-2" style={{ padding: "6px" }}>
          <div className="report-section bg-white p-3">
            <h4>Distribution Network Report</h4>
            <DistributionNetworkReportChart />
          </div>
        </div>
      </div>
      <style jsx>{`
        .text-wrapper {
          padding-left: 10px;
          margin-bottom: 10px;
        }
        .m-wrapper > h3 {
          font-size: 24px;
          font-weight: 600;
        }
        svg,
        path {
          fil: #fff;
        }
      `}</style>
    </>
  );
};

export default AdminReports;
